import { LoginComponent } from "../app/components/login/login.component";

export const environment = {
  production: false,
  language: "sl",  
  wgProfileHost: "https://ekolesa-api.borzen.si",
  wgPlatformHost: "https://ekolesa-platform.borzen.si",

  loginComponent: LoginComponent,
  projIcon: "/assets/project-custom/images/borzen_logo_new.png",
  sidebarIcon: "/assets/project-custom/images/borzen_logo_new.png",
  projectCode: "BORZEN_EB",
  projectName: "",
  locale: 'sl-SI',
  useRouteAndMasterpageCache: true,
  ADLoginEnabled: false,
  dateFormat: 'DD.MM.YYYY',
  navigateAwayPopupEnabled: true,
  useEtag: true,
  newRegistrationLinkDocument: "",
  maxChunkNumber: 40,
  maxFileSizeInMb: 5,
  maxRecordNumberPerPageListing: 30,
  cacheEnabled: false,
  version: '1.1.0',
  showOnlyUserInHeader: true,
  googleClientId: "344277045222-3hu9qar7d5v78ncjsg5j4fc7p62gunkv.apps.googleusercontent.com",
  useOldSearchViewFeature: false,
  usernameAlwaysToLower: true, // need this shit for EVOZILA1
  useInlineSearch: false,
  maxFileSizeInMbInMessenger: 5,
  projectSidebarName: ""
};

